<div
  *ngIf="viewModel$ | async as viewModel"
  class="field-container"
  [hidden]="viewModel.hidden"
>
  <ng-container *ngIf="formElement.elementType === 'section'">
    <p-accordion *ngIf="formElement.renderAsAccordion">
      <p-accordionTab
        [headerStyleClass]="
          viewModel.aboveSharedJobOverlay ? 'above-shared-job-overlay' : undefined
        "
      >
        <ng-template pTemplate="header">
          <div class="custom-header-content">
            <i
              *ngIf="formElement.icon"
              [class]="formElement.icon"
              style="margin-right: 8px"
            ></i>
            <span style="font-weight: bold">{{ formElement.title }}</span>
            <span style="margin-left: auto">
              <app-calculator-field
                *ngIf="formElement.headerTotal"
                [formElement]="formElement.headerTotal"
                [plain]="true"
              ></app-calculator-field>
            </span>
          </div>
        </ng-template>

        <p
          class="calculator-description"
          *ngIf="formElement.description"
        >
          {{ formElement.description }}
        </p>

        <app-calculator-field
          *ngFor="
            let childElement of formElement.elements;
            let childIndex = index;
            trackBy: trackByKey
          "
          [formElement]="childElement"
        ></app-calculator-field>
      </p-accordionTab>
    </p-accordion>
    <ng-container *ngIf="!formElement.renderAsAccordion">
      <h4 *ngIf="formElement.title">{{ formElement.title }}</h4>

      <p
        class="calculator-description"
        *ngIf="formElement.description"
      >
        {{ formElement.description }}
      </p>

      <app-calculator-field
        *ngFor="
          let childElement of formElement.elements;
          let childIndex = index;
          trackBy: trackByKey
        "
        [formElement]="childElement"
      ></app-calculator-field>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="formElement.elementType !== 'section'">

    <!-- crew_pay_table: full-width, renders standalone inside the accordion content area -->
    <ng-container *ngIf="formElement.elementType === 'crew_pay_table'">
      <app-crew-pay-table></app-crew-pay-table>
    </ng-container>

    <!-- fp_revenue_split_table: full-width, renders standalone inside the accordion content area -->
    <ng-container *ngIf="formElement.elementType === 'fp_revenue_split_table'">
      <app-fp-revenue-split-table></app-fp-revenue-split-table>
    </ng-container>

    <!-- date_picker: full-width block with optional label above the picker + card -->
    <ng-container *ngIf="formElement.elementType === 'date_picker'; else notDatePicker">
      <div class="p-field calc-date-picker-wrapper">
        <label *ngIf="formElement.title">{{ formElement.title }}</label>
        <app-calculator-date-picker
          (dateSelected)="store.dispatch(calculatorActions.inputChanged({ key: formElement.key, value: $event }))"
        ></app-calculator-date-picker>
      </div>
    </ng-container>

    <ng-template #notDatePicker>
    <ng-container *ngIf="formElement.elementType !== 'crew_pay_table' && formElement.elementType !== 'fp_revenue_split_table'">
    <ng-container *ngIf="!plain; else plainElement">
      <div
        *ngIf="insideGrid; else gridless"
        class="p-field p-ai-center p-grid"
        [ngClass]="formElement.className"
      >
        <label class="p-col-12 p-md-5">{{ formElement.title }}</label>
        <div class="p-col-12 p-md-7">
          <ng-container *ngTemplateOutlet="plainElement"></ng-container>
        </div>
      </div>
      <ng-template #gridless>
        <div class="p-field p-ai-center">
          <ng-container *ngTemplateOutlet="plainElement"></ng-container>
        </div>
      </ng-template>
    </ng-container>

    <ng-template #plainElement>
      <div
        class="p-inputgroup"
        *ngIf="isInput; else output"
      >
        <ng-container [ngSwitch]="formElement.elementType">
          <input
            #inputText
            *ngSwitchCase="'input_text'"
            pInputText
            [class]="formElement.className"
            [value]="viewModel.value || ''"
            [placeholder]="viewModel.placeholder"
            (input)="
              store.dispatch(
                calculatorActions.inputChanged({
                  key: formElement.key,
                  value: $event.target.value,
                })
              )
            "
            [suffix]="formElement.suffix"
          />

          <p-inputNumber
            #inputNumber
            *ngSwitchCase="'input_number'"
            type="number"
            mode="decimal"
            [step]="formElement.step ?? 1"
            [minFractionDigits]="formElement.minFractionDigits"
            [maxFractionDigits]="formElement.maxFractionDigits"
            [ngModel]="viewModel.value"
            [placeholder]="inputNumber.formatValue(viewModel.placeholder)"
            [suffix]="formElement.suffix"
            (ngModelChange)="
              store.dispatch(
                calculatorActions.inputChanged({
                  key: formElement.key,
                  value: $event,
                })
              )
            "
          ></p-inputNumber>

          <p-inputNumber
            #inputCurrency
            *ngSwitchCase="'input_currency'"
            mode="currency"
            [currency]="viewModel.currency"
            [locale]="viewModel.currency === 'CAD' ? 'en-CA' : 'en-US'"
            [class]="formElement.className"
            [step]="formElement.step ?? 1"
            [min]="formElement.min ?? null"
            [ngModel]="viewModel.value"
            [placeholder]="inputCurrency.formatValue(viewModel.placeholder)"
            (ngModelChange)="
              store.dispatch(
                calculatorActions.inputChanged({
                  key: formElement.key,
                  value: $event,
                })
              )
            "
            [suffix]="formElement.suffix"
          ></p-inputNumber>

          <p-dropdown
            *ngSwitchCase="'select_dropdown'"
            [options]="formElement.options"
            [class]="viewModel.className"
            [ngModel]="viewModel.value"
            [placeholder]="formElement.placeholder"
            (ngModelChange)="
              $event === undefined ? false : store.dispatch(
                calculatorActions.inputChanged({
                  key: formElement.key,
                  value: $event,
                })
              )
            "
          ></p-dropdown>

          <p-slider
            *ngSwitchCase="'slider'"
            [ngModel]="viewModel.value"
            data-value="{{viewModel.value}}"
            [min]="formElement.min || viewModel.min || 0"
            [max]="formElement.max || viewModel.max || 0"
            [step]="formElement.step"
            (ngModelChange)="
              store.dispatch(
                calculatorActions.inputChanged({
                  key: formElement.key,
                  value: $event,
                })
              )
            "
          ></p-slider>

          <p-checkbox
            *ngSwitchCase="'checkbox'"
            [binary]="true"
            [ngModel]="viewModel.value"
            (onChange)="
              store.dispatch(
                calculatorActions.inputChanged({
                  key: formElement.key,
                  value: $event.checked,
                })
              )
            "
          ></p-checkbox>

          <button
            *ngSwitchCase="'button'"
            pButton
            type="button"
            [label]="formElement.label"
            [disabled]="formElement.disabled || false"
            (click)="
              store.dispatch(
                calculatorActions.calculatorButtonClicked({
                  key: formElement.key,
                  action: formElement.action
                })
              )
            "
          ></button>
        </ng-container>

        <button
          *ngIf="viewModel.showResetButton"
          pButton
          type="button"
          icon="pi pi-replay"
          outlined="true"
          pTooltip="Reset"
          tabindex="-1"
          (click)="
            store.dispatch(
              calculatorActions.inputReset({ key: formElement.key })
            )
          "
        ></button>
      </div>

      <ng-template #output>
        <ng-container [ngSwitch]="formElement.elementType">
          <ng-container *ngSwitchCase="'output_text'">
            <span>{{ formElement.value || viewModel.value }}</span>
            <span
              *ngIf="formElement.suffix"
              class="p-ml-1"
            >{{
              formElement.suffix
              }}</span>
          </ng-container>
          <ng-container *ngSwitchCase="'output_number'">
            <span>
              {{
              viewModel.value
              | number
              : formElement.numberFormat?.digitsInfo
              : formElement.numberFormat?.locale
              }}
            </span>
            <span
              *ngIf="formElement.suffix"
              class="p-ml-1"
            >{{
              formElement.suffix
              }}</span>
          </ng-container>
          <span *ngSwitchCase="'output_percent'">
            {{ viewModel.value * 100 | number: '1.2-2' }}%
          </span>
          <ng-container *ngSwitchCase="'output_currency'">
            <span>{{ viewModel.value | currency: viewModel.currency }}</span>
            <span
              *ngIf="formElement.suffix"
              class="p-ml-1"
            >{{
              formElement.suffix
              }}</span>
          </ng-container>
          <ng-container *ngSwitchCase="'message'">
            <p-messages [value]="[{
                severity: formElement.severity || 'info',
                summary: formElement.summary,
                detail: formElement.detail || viewModel.value,
                closable: false
              }]"></p-messages>
          </ng-container>

          <ng-container *ngSwitchCase="'heading'">
            <h4>{{ formElement.title }}</h4>
            <p
              class="calculator-description"
              *ngIf="formElement.description"
            >
              {{ formElement.description }}
            </p>
          </ng-container>

          <hr *ngSwitchCase="'divider'" />

          <ng-container *ngSwitchCase="'table'">
            <h4 *ngIf="formElement.title">{{ formElement.title }}</h4>
            <p *ngIf="formElement.description">{{ formElement.description }}</p>
            <p-table
              [value]="viewModel.value"
              [rowTrackBy]="trackByKey"
            >
              <ng-template pTemplate="header">
                <tr>
                  <th *ngFor="let col of formElement.columns">
                    {{ col.header }}
                  </th>
                </tr>
              </ng-template>

              <ng-template
                pTemplate="body"
                let-rowData
                let-rowIndex="rowIndex"
              >
                <tr>
                  <td *ngFor="let col of formElement.columns; trackBy: trackByKey">
                    <app-calculator-field
                      [formElement]="{
                        key:
                          formElement.key +
                          delimiter +
                          rowData.key +
                          delimiter +
                          col.key,
                        elementType: col.elementType,
                      }"
                      [elementIndex]="rowIndex"
                      [plain]="true"
                    ></app-calculator-field>
                  </td>
                </tr>
              </ng-template>
              <ng-template
                pTemplate="footer"
                let-rowData
                let-rowIndex="rowIndex"
              >
                <tr *ngIf="formElement.footer">
                  <td *ngFor="
                      let col of formElement.columns;
                      let footerIndex = index;
                      trackBy: trackByKey
                    ">
                    <app-calculator-field
                      *ngIf="formElement.footer?.[col.key]"
                      [formElement]="formElement.footer[col.key]"
                      [elementIndex]="rowIndex"
                      [plain]="true"
                    ></app-calculator-field>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </ng-container>
        </ng-container>
      </ng-template>
    </ng-template>
    </ng-container> <!-- /not crew_pay_table -->
    </ng-template> <!-- /notDatePicker -->
  </ng-container>
</div>
